import { AbstractControl, AsyncValidator, ValidationErrors, Validators } from '@angular/forms';
import { UserService } from '../services/users.service';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../app.config';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

const NUMERIC = '[0-9]+';
const WEBSITE = '(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})';
const EMAIL = '(([^<>()\\[\\]\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\.,;:\\s@"]+)*)|(".+"))' +
  '@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|([0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3})' +
  '|([^<>()/\\\&?\\-.,;:]+([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))';

export function numberValidator(control: AbstractControl): ValidationErrors | null {

    const hasError = control.value ? Validators.compose([
      Validators.pattern(NUMERIC)
    ])(control) : false;

    return hasError ? {numberValidator: true} : null;
  }

export function websiteValidator(control: AbstractControl): ValidationErrors | null {

  const hasError = control.value ? Validators.compose([
    Validators.pattern(WEBSITE)
  ])(control) : false;

  return hasError ? {websiteValidator: true} : null;
}

export function emailValidator(control: AbstractControl): ValidationErrors | null {

  const hasError = control.value ? Validators.compose([
    Validators.pattern(EMAIL)
  ])(control) : false;

  return hasError ? {emailValidator: true} : null;
}

export function checkEmailOnServer(control: AbstractControl): ValidationErrors | null{

  // const hasError = control.value ? Validators.compose([
  //   Validators.pattern(EMAIL)
  // ])(control) : false;
  //
  //   return UserService.checkEmail(control.value).pipe(map(result => (result ? { duplicateEmail: true } : null)));
  //   // console.log(error);
  return null;
}



